export default function generateRandomId() {
  return `id_${Math.random().toString(36).substring(2, 11)}_${Date.now()}`
}
